import React from "react";
import "../../global.scss";
import { IonCol, IonText, IonButton, IonLabel, IonInput, IonImg } from "@ionic/react";
import {
	RECOMMENDED_SERVICES,
	YOU_DONT_HAVE_ANY_VEHICLES_ADDED,
	ADD_A_NEW_VEHICLE,
	TO_SEE_LIST_OF_RECOMMENDED_SERVICES,
	BOOK_A_SERVICE,
	NO_ACTIVE_SERVICES_AVAILABLE,
	ESTIMATED_COST,
	ADD,
	RECOMMENDED,
} from "../../constants";
import ServicePill from "./BookService/servicePill";

const RecommendedService: React.FC = (props: any) => {
	const { searchRecommendations = [], userVehiclesList = [] } = props;

	return (
		<>
			<IonCol className="pd_0 pd-10 mg-bottom_20" size="12">
				<IonText className="responsive-text" color="secondary">
					{RECOMMENDED_SERVICES}
				</IonText>
				{Boolean((userVehiclesList || []).length) ? (
					Boolean((searchRecommendations || []).length) &&
					searchRecommendations.map((record: any, index: any) => (
						<ServicePill {...record.recommended} {...props} key={index} />
					))
				) : (
					<>
						<div className="my_service_status margin-left-0">
							<IonText className="active_service">
								{YOU_DONT_HAVE_ANY_VEHICLES_ADDED}
							</IonText>
							<div>
								<IonButton
									color="primary"
									className="book_btn"
									expand="block"
									onClick={() => props.history.push("/portal/add-vehicles")}
								>
									{ADD_A_NEW_VEHICLE}
								</IonButton>
							</div>
							<IonText className="over_2k">{TO_SEE_LIST_OF_RECOMMENDED_SERVICES}</IonText>
						</div>
						<IonCol className="responsive_screen p-0" size="12" size-sm size-md="9">
							<div
								className="book_serivice_res margin-17"
								onClick={() => props.history.push("/portal/add-vehicles")}
							>
								<IonLabel className="book_service_text" color="primary">
									{ADD_A_NEW_VEHICLE}
									<p className="no_services"> {TO_SEE_LIST_OF_RECOMMENDED_SERVICES}</p>
								</IonLabel>
								<IonImg className="right_arrow" src="/images/book_service.svg" />
							</div>
						</IonCol>
					</>
				)}
			</IonCol>
		</>
	);
};
export default RecommendedService;
